import React from 'react';
import './ReceiptLineSummary.scss';
import { CurrencyUtils } from '../../utils';

interface ReceiptLineSummaryProps {
    summaryTitle: string;
    summaryValue: number | string;
    currency: string;
    locale: string;
    className?: string;
}

export const ReceiptLineSummary: React.FC<ReceiptLineSummaryProps> = (props) => {
    const { summaryValue, currency, summaryTitle, locale, className } = props;
    const value = typeof summaryValue === 'string' ? summaryValue : CurrencyUtils.formatCurrency(summaryValue, currency, locale);

    return (
        <div className={`receipt-line-summary ${className || ''}`}>
            <div>
                <span className={'body-regular'} tabIndex={0} aria-label={`${summaryTitle} ${value}`}>
                    {summaryTitle}
                </span>
            </div>
            <div className="receipt-line-summary-value">
                <span className={'body-regular'}>{value}</span>
            </div>
        </div>
    );
};
